import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

/** Same header background as non-sort columns (category); overrides global yellow sorter style for this table only. */
export const ContentPagesBlogTableWrap = styled.div`
  .ant-table-thead > tr:first-child > th.ant-table-column-has-sorters,
  .ant-table-thead > tr:first-child > th.ant-table-column-sort {
    background-color: ${COLORS.DARK_BLUE} !important;
    color: ${COLORS.WHITE};

    .ant-table-column-title {
      color: ${COLORS.WHITE};
    }

    .ant-table-column-sorter {
      color: ${COLORS.WHITE};
    }

    .ant-table-column-sorter-up.active,
    .ant-table-column-sorter-down.active {
      color: ${COLORS.YELLOW_PRIMARY};
    }
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;

export const StyledListHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  min-height: 6.75rem;
  background: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledListPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledPaginationWrap = styled.div`
  margin-top: 1.5rem;
`;
